<template>
  <div class="top">
    <h1>
      <span>{{config.ClassCname}}报考指南</span>
      <label>专栏</label>
    </h1>
    <div class="content timeline" v-if="config.time" v-html="config.time">
    </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.top{
  background: url(https://img2.233.com/wx/union/response/novice/pc-bg.png) no-repeat top center;
  h1{
    text-align: center;
    padding: 40px 0 35px;
    span{
      font-size: 48px;
      color: #fff;
      font-weight: bold;
      line-height: 56px;
    }
    label{
      font-size: 16px;
      line-height: 16px;
      color: #333;
      font-weight: 400;
      padding: 2px 5px;
      background: #fff;
      display: inline-block;
      border-radius: 2px;
      vertical-align: top;
      margin-left: 25px;
    }
  }
  .timeline{
    margin: 0 auto;
    /deep/.time{
      margin: 0;
    }
  }
}
</style>